import React, { FC, ReactElement } from "react";
import { PageProps } from "gatsby";
import { Layout } from "../components/Layout/Layout";
import { SEO } from "../components/SEO/SEO";

const CommunityPage: FC<PageProps> = (): ReactElement => {
	return (
		<Layout>
			<SEO
				title="Community"
				description="Ask for help and connect with other Adeptly users in our community space."
			/>
			<iframe
				title="Adeptly Community - Ask for Help"
				src="https://community.adeptly.ai/c/ask-for-help/"
				style={{ border: "none", width: "100%", height: "100vh" }}
			/>
		</Layout>
	);
};

export default CommunityPage;


